// Use relative URLs to go through the React proxy to your backend
const API_BASE_URL = '/api';

export const getFilterConfiguration = async (projectId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/filters/config`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        projectId: projectId || '0000000093'
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const filters = await response.json();

    if (Array.isArray(filters)) {
      console.log(`Backend returned ${filters.length} filterable fields`);
      return filters;
    } else if (filters.error) {
      throw new Error(filters.error);
    } else {
      throw new Error('Invalid response format from server');
    }
  } catch (error) {
    console.error('Filter API error:', error.message);
    throw error; // Re-throw the error instead of falling back to mock data
  }
};

// Remove all direct API calls - frontend should only use backend endpoints

export const getFacetData = async (projectId, fieldNames) => {
  try {
    if (!fieldNames || fieldNames.length === 0) {
      return {};
    }

    const response = await fetch(`${API_BASE_URL}/filters/facets`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        projectId: projectId || '0000000093',
        facetFields: fieldNames
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data.success && data.facets) {
      console.log('Backend returned facet data:', data.facets);
      // Transform the new format to match what the frontend expects
      const transformedFacets = {};
      Object.keys(data.facets).forEach(fieldName => {
        transformedFacets[fieldName] = {
          buckets: data.facets[fieldName].map(item => ({
            val: item.value,
            count: item.count
          }))
        };
      });
      return transformedFacets;
    } else if (data.error) {
      throw new Error(data.error);
    } else {
      throw new Error('Invalid response format from server');
    }
  } catch (error) {
    console.error('Facet API error:', error.message);
    throw error; // Re-throw the error instead of falling back to mock data
  }
};

export const buildSolrFilterQuery = (filters, availableFilters = []) => {
  if (!filters || Object.keys(filters).length === 0) {
    return '';
  }

  const filterClauses = [];

  Object.entries(filters).forEach(([filterKey, values]) => {
    if (values && values.length > 0) {
      // Find the filter configuration to get the correct Solr field name
      const filterConfig = availableFilters.find(f => f.key === filterKey);

      // Use srch_field if available, otherwise fallback to the key
      const solrFieldName = filterConfig?.srch_field || filterKey;

      console.log(`Filter mapping: ${filterKey} -> ${solrFieldName}`, filterConfig);

      if (values.length === 1) {
        filterClauses.push(`${solrFieldName}:${values[0]}`);
      } else {
        const orClause = values.map(value => `${value}`).join(' OR ');
        filterClauses.push(`${solrFieldName}:(${orClause})`);
      }
    }
  });

  return filterClauses.length > 0 ? ` AND ${filterClauses.join(' AND ')}` : '';
};

export const buildDateRangeQuery = (fieldName, startDate, endDate) => {
  if (!startDate && !endDate) {
    return '';
  }

  const start = startDate ? `${startDate}T00:00:00Z` : '*';
  const end = endDate ? `${endDate}T23:59:59Z` : '*';

  console.log(`Date filter: ${fieldName}:[${start} TO ${end}]`);
  return ` AND ${fieldName}:[${start} TO ${end}]`;
};